import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {RouterModule} from "@angular/router";
import {LoginMailComponent} from "../users/login/login-mail/login-mail.component";
import {LoginPage} from "../users/login/login.page";
import {RegisterFeaturePage} from "../register-feature/register-feature.page";
import {ModalPagesContainerComponent} from "../shared/components/modal-pages-container/modal-pages-container.component";
import {ModalHeaderComponent} from "../shared/components/modal-header/modal-header.component";
import {FormControlConverterPipe} from "../shared/pipe/form-control-converter.pipe";
import {SimpleInputComponent} from "../shared/components/simple-input/simple-input.component";
import {RegisterPage} from "../users/register/register.page";
import {LottieComponent} from "ngx-lottie";
import {RegisterSocialPage} from "../users/register-social/register-social.page";
import {UserProfileFormComponent} from "../shared/components/user-profile-form/user-profile-form.component";
import {FormsModule} from "@angular/forms";
import {PrivacyModalComponent} from "../privacy/privacy-modal/privacy-modal.component";


@NgModule({
  declarations: [
    ModalPagesContainerComponent,
    LoginMailComponent,
    LoginPage,
    RegisterFeaturePage,
    RegisterPage,
    RegisterSocialPage,
    PrivacyModalComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        ModalHeaderComponent,
        FormControlConverterPipe,
        SimpleInputComponent,
        LottieComponent,
        UserProfileFormComponent,
        FormsModule
    ],
  exports: [RouterModule]
})
export class ModalNavigatorModule { }
